// extracted by mini-css-extract-plugin
module.exports =  {"tc-action-button-skeleton-circle":"ActionButton-module__tc-action-button-skeleton-circle___FTCPF"};